import { graphql } from '../../../graphql/generated';

export const CREATE_DOCTOR_MUTATION = graphql(`
  mutation CreateDoctor($input: DoctorInput!) {
    createDoctor(input: $input) {
      id
    }
  }
`);
